import React from 'react';
import cx from 'classnames';
import styles from './index.less';

const MoClaimSuccess = ({ onClose }) => (
  <div className={styles.root}>
    <div className={styles.group26} data-name="弹窗:领取成功">
      <div className={styles.layer49} data-name="弹窗-背景底框" />
      <button type="button" className={cx(styles.layer50, styles.modalButton)} data-name="弹窗-关闭按钮" onClick={onClose} />
      <div className={styles.group27} data-name="弹窗-主体区域">
        <div className={styles.layer51} data-name="分享奖励已发放至绑定角色， 请前往游戏内查收">
          分享奖励已发放至绑定角色，{'\n'}请前往游戏内查收
        </div>
        <button type="button" className={cx(styles.layer52, styles.modalButton)} data-name="完成按钮" onClick={onClose} />
      </div>
    </div>
  </div>
);

export default MoClaimSuccess;
